import { Alert } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButtonDetails from 'src/components/LinkButtonDetails/LinkButtonDetails';

type Props = {
  items: { rowNumber: number; orgNo: string }[];
};

const InvalidOrganizationNumbersNotification: React.FC<Props> = ({ items }) => {
  const { t: tCommon } = useTranslation();
  const { t: tResourceBase } = useTranslation('resourceBase');

  if (items.length === 0) {
    return null;
  }

  return (
    <Alert data-color="danger" className="margin-bottom--2">
      <p>{tResourceBase('import.invalidOrgNoFound')}</p>
      <LinkButtonDetails text={tResourceBase('showInvalidOrgNumbers')}>
        <ul>
          {Array.from(new Set(items)).map(({ orgNo, rowNumber }, index) => (
            <li key={index}>
              {orgNo} ({tCommon('row')}: {rowNumber})
            </li>
          ))}
        </ul>
      </LinkButtonDetails>
    </Alert>
  );
};

export default InvalidOrganizationNumbersNotification;
